import { Alert, LoadingButton, Paper, Typography } from "@firecms/ui";
import { type AdminOfflineDownloadsCountResult } from "@repo/common";
import { useQuery } from "@tanstack/react-query";

import AdminToolPage from "components/molecules/AdminToolPage";
import { getErrorMessage } from "lib/error.utils";
import { queryKeys } from "lib/query-keys";
import { fetchAdminOfflineDownloadsCount } from "services/admin-tools/adminTools";

const TOOL_DESCRIPTION =
  "Zählt Offline-Download-Audit-Einträge in Firestore: aktive Downloads im TTL-Fenster, betroffene Nutzer und gespeicherte Zeilen insgesamt.";

const AdminOfflineDownloadsCount: React.FC = () => {
  const { data, error, isFetching, refetch, isFetched } = useQuery<AdminOfflineDownloadsCountResult>({
    queryKey: queryKeys.adminTools.offlineDownloadsCount(),
    queryFn: fetchAdminOfflineDownloadsCount,
    enabled: false,
  });

  return (
    <AdminToolPage title="Offline-Downloads" description={TOOL_DESCRIPTION}>
      <LoadingButton loading={isFetching} disabled={isFetching} onClick={() => void refetch()}>
        Zähler aktualisieren
      </LoadingButton>

      {error ? <Alert color="error">{getErrorMessage(error)}</Alert> : null}

      {isFetched && data ? (
        <Paper className="flex flex-col gap-3 p-4">
          <Typography>
            Aktuelle Offline-Downloads (letzte {data.ttlDays} Tage):{" "}
            <strong>{data.currentCount.toLocaleString("de-DE")}</strong>
          </Typography>
          <Typography>
            Nutzer mit aktiven Offline-Downloads: <strong>{data.currentUsersCount.toLocaleString("de-DE")}</strong>
          </Typography>
          <Typography>
            Gespeicherte Audit-Zeilen (gesamt): <strong>{data.allStoredCount.toLocaleString("de-DE")}</strong>
          </Typography>
          <Typography variant="caption" color="secondary">
            Cutoff (UTC): {new Date(data.cutoffUtc).toLocaleString("de-DE")}
          </Typography>
        </Paper>
      ) : null}
    </AdminToolPage>
  );
};

export default AdminOfflineDownloadsCount;
